<template>
  <div id="footer">
    <a target="_blank" href="https://beian.miit.gov.cn">京ICP备2022024428号-1</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 50px;
  background: #474747;
  overflow: hidden;
  text-align: center;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 导航栏logo图片 */
.logo img {
  object-fit: cover;
}

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue